export const QUERY_PARAM_DELIMITER = '§';

export interface Filters {
	fieldOfArea: string[];
	area: string[];
}

export const filtersToSearchParams = (filters: Filters) => {
	const searchParams = new URLSearchParams();

	Object.entries(filters).forEach(([key, value]) => {
		if (value.length > 0) {
			searchParams.set(key, value.join(QUERY_PARAM_DELIMITER));
		}
	});

	return searchParams;
};

export const searchParamsToFilters = (searchParams: URLSearchParams) => {
	const filters: Filters = {
		fieldOfArea: [],
		area: [],
	};

	searchParams.forEach((value, key) => {
		if (value) {
			filters[key as keyof Filters] = value.split(QUERY_PARAM_DELIMITER);
		}
	});

	return filters;
};
